import { action, createRequestTypes } from '../base';

export const vendorRatingActionTypes = {
  UPDATE_VENDOR_RATING_CONFIG: createRequestTypes('UPDATE_VENDOR_RATING_CONFIG'),
  UPDATE_VENDOR_RATING: createRequestTypes('UPDATE_VENDOR_RATING'),
  GET_VENDOR_RATING_CONFIG: createRequestTypes('GET_VENDOR_RATING_CONFIG'),
  CREATE_VENDOR_RATING: createRequestTypes('CREATE_VENDOR_RATING'),
  ENABLE_VENDOR_RATING_CONFIG: createRequestTypes('ENABLE_VENDOR_RATING_CONFIG'),
};

/**
 *
 * @param payload
 * @param orgId
 * @param callback
 */
class VendorRatingActions {
  createVendorRating = (payload, callback) => action(vendorRatingActionTypes.CREATE_VENDOR_RATING.REQUEST, {
    payload,
    callback,
  });

  createVendorRatingLoading = (createSellerRatingLoading) => action(vendorRatingActionTypes.CREATE_VENDOR_RATING.LOADING, {
    createSellerRatingLoading,
  })

  updateVendorRating = (payload, callback) => action(vendorRatingActionTypes.UPDATE_VENDOR_RATING.REQUEST, {
    payload,
    callback,
  });

  updateVendorRatingLoading = (updateVendorRatingLoading) => action(vendorRatingActionTypes.UPDATE_VENDOR_RATING.LOADING, {
    updateVendorRatingLoading,
  })

    /**
     *
     * @param payload
     * @param callback
     */
    getVendorRating= (orgId, callback) => action(vendorRatingActionTypes.GET_VENDOR_RATING_CONFIG.REQUEST, {
      orgId, callback,
    })

    /**
     *
     * @return
     */
     getVendorRatingLoading = (getVendorRatingLoading) => action(vendorRatingActionTypes.GET_VENDOR_RATING_CONFIG.LOADING, {
       getVendorRatingLoading,
     })

     /**
      * @return
      */
     getVendorRatingSuccess = (getVendorRatingSuccess) => action(vendorRatingActionTypes.GET_VENDOR_RATING_CONFIG.SUCCESS, {
       getVendorRatingSuccess,
     })

     updateVendorRatingSetting = (payload, callback) => action(vendorRatingActionTypes.UPDATE_VENDOR_RATING_CONFIG.REQUEST, {
       payload,
       callback,
     });

     /**
      *
      * @return
      */
     updateVendorRatingSettingLoading = (updateVendorRatingSettingLoading) => action(vendorRatingActionTypes.UPDATE_VENDOR_RATING_CONFIG.LOADING, {
       updateVendorRatingSettingLoading,
     })

     enableVendorRatingConfig = (payload, callback) => action(vendorRatingActionTypes.ENABLE_VENDOR_RATING_CONFIG.REQUEST, {
       payload,
       callback,
     });

     enableVendorRatingConfigLoading = (enableVendorRatingConfigLoading) => action(vendorRatingActionTypes.ENABLE_VENDOR_RATING_CONFIG.LOADING, {
       enableVendorRatingConfigLoading,
     })
}

export default new VendorRatingActions();
